import React from 'react';
import styles from './TableContent.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { tooltipStyle, tooltip, timePeriodCell } from '@/components/TableCell';

class TableContent extends React.Component {

    _columns = () => [
        {
            title: '手机号码',
            dataIndex: 'tel',
            key: 'tel',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '封禁周期',
            dataIndex: 'period',
            key: 'period',
            width: '14%',
            align: 'center',
            onCell: tooltipStyle,
            render: (text, item) => timePeriodCell(item.gmtCreate, item.endTime)
        },
        {
            title: '账户类型',
            dataIndex: 'blockAccountTypeValue',
            key: 'blockAccountTypeValue',
            width: '6%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '状态',
            dataIndex: 'stateValue',
            key: 'stateValue',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '原因',
            dataIndex: 'reason',
            key: 'reason',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '处罚说明',
            dataIndex: 'remark',
            key: 'remark',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '生成时间',
            dataIndex: 'gmtCreate',
            key: 'gmtCreate',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '解封原因',
            dataIndex: 'unblockRemark',
            key: 'unblockRemark',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '解封时间',
            dataIndex: 'gmtUnblock',
            key: 'gmtUnblock',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            width: '10%',
            align: 'center',
            render: (id, item) => this._TableAction(item)
        },
    ];

    _takeDataSource = (data) => {
        if (Array.isArray(data)) {
            return data.map((item) => {
                item.period = item.gmtCreate + item.endTime;
                return item;
            });
        } else {
            return [];
        }
    }

    _TableAction = (record) => {
        const { tableAction } = this.props;
        const showText = record.state == 'BLOCKING' ? true : false;
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction('history', record)}>历史记录</div>
                {showText ? <div className={styles.item} onClick={() => tableAction('lockdown', record)}>解封</div> : null}
            </div>
        );
    };

    render() {
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;

        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    columns={this._columns()}
                    rowKey={(r) => r.id}
                    dataSource={this._takeDataSource(dataList)}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableContent.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};
export default TableContent;

